<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item,index) in pendingTabBars"
          class="tab-text"
          :key="index"
        >
          <el-form class="search-style" label-width="45px" :model="queryParams">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item label="仓库：">
                  <el-select
                    v-model="queryParams.storageName"
                    @change="changeStorage"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item,index) in stockSelect"
                      :key="index"
                      :label="item.storageName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="货架：">
                  <el-select v-model="queryParams.shelvesName"  filterable>
                    <el-option
                      v-for="(item,index) in shelfSelect"
                      :key="index"
                      :label="item.shelvesName"
                      :value="item.ssId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="padding-left:10px !important">
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button  @click="onReset">重置</el-button>
              </el-col>
              <el-col :span='12' style='text-align:right'>
                  <el-button  @click="onBatch" v-show="auditState === 1" type="primary">批量认领</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height:tableHeight+'px'}">
            <el-table
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="list"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              :max-height="tableHeight"
              element-loading-spinner="el-icon-loading"
               @selection-change="handleSelectionChange"
            >
              <el-table-column key='1' type="selection" width="55"  :selectable="selectableFun" v-if="activeName === 'pending'"></el-table-column>
              <el-table-column width="50px" type='index' label="⋮" key='2' v-if="activeName !== 'pending'"></el-table-column>
              <el-table-column label="盘点类型" width="140px" key='3'>
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.inventoryType === 1">整库盘点</span>
                    <span v-else-if="scope.row.inventoryType === 2">实时盘点</span>
                    <span v-else-if="scope.row.inventoryType === 3">备货报缺</span>
                    <span v-else-if="scope.row.inventoryType === 4">出库报缺</span>
                    <span v-else-if="scope.row.inventoryType === 5">调拨报缺</span>
                    <span v-else>{{'--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="仓库" key='4'>
                <template slot-scope="scope">
                  <div>{{scope.row.storageName}}</div>
                </template>
              </el-table-column>
              <el-table-column label="货架" key='5'>
                <template slot-scope="scope">
                  <div>{{scope.row.shelvesName}}</div>
                </template>
              </el-table-column>
              <el-table-column label="盘点人" key='6'>
                <template slot-scope="scope">
                  <div>{{scope.row.inventoryUser}}</div>
                </template>
              </el-table-column>
              <el-table-column label="盘点时间" key='7'>
                <template slot-scope="scope">
                  <div>{{scope.row.inventoryDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="认领人" key='8'>
                <template slot-scope="scope">
                  <div>{{scope.row.auditUser || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="认领时间" key='9' v-if="activeName !== 'myAudited'">
               <template slot-scope="scope">
                  <div>{{scope.row.processDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="处理时间" key='10' v-if="activeName === 'myAudited'">
               <template slot-scope="scope">
                  <div>{{scope.row.auditDate|dateFilterL}}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" key='11' width="200px">
                <template slot-scope="scope" fixed="right">
                   <el-button
                    type="text"
                    @click="claimantDetail(scope.row)"
                    v-if="scope.row.auditUser === null"
                  >认领</el-button>
                  <el-button
                    type="text"
                    @click="handleDetail(scope.row)"
                    v-if="scope.row.auditUser !== localUser && scope.row.auditUser !== null && scope.row.stockPower === 2"
                  >提取</el-button>
                  <el-button
                    type="text"
                    @click="toDetail(scope.row)"
                    v-if="scope.row.auditUser === localUser && activeName !== 'myAudited'"
                  >处理</el-button>
                  <el-button
                    type="text"
                    v-show="activeName === 'myAudited'"
                    @click="toCheck(scope.row.sisId,activeName)"
                    style="margin-left:0px"
                  >查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
            <div class="pagination"  style="padding-top:20px">
              <pagination
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
              ></pagination>
            </div>
        </el-tab-pane>
      </el-tabs>
      <open-or-close
      @onUpdataState="onUpdataState"
      content="确认是否批量认领？"
      title="提示"
      ref="openOrCloseRefs"
    ></open-or-close>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { pendingTabBars } from './util/data'
import { getAuth } from '../../../util/auth'
import { queryPageAllInventory, queryBySbIdSsId, updateAuditState, updateAuditStateExtract } from '@/api/storage/storage'
import OpenOrClose from '@/components/OpenOrClose/index'

export default {
  components: {
    pagination,
    'open-or-close': OpenOrClose

  },
  data () {
    return {
      tableHeight: window.innerHeight - 390,
      userName: '', // 登录账号名称
      activeName: 'pending',
      pendingTabBars: pendingTabBars, // tabs状态
      queryParams: {
      },
      stockSelect: [], // 仓库列表
      shelfSelect: [], // 货架列表
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      auditState: 1,
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      time: [],
      tempList: [],
      checkList: []

    }
  },
  mounted () {
    this.getUser() // 获取当前用户信息
    this.gethouseList() // 获取仓库
    this.getList() // tab 表格切换数据
  },
  watch: { // 监听父级tabs状态请求列表接口
    activeName () {
      this.tabActiveName = this.activeName
      this.queryParams = {}
    }
  },
  methods: {
    // 获取当前用户信息
    getUser () {
      this.localUser = JSON.parse(getAuth()).usercnname
    },
    // 获取仓库信息
    async gethouseList () {
      this.stockSelect = await this.$houseInformation()
    },
    // 获取货架
    changeStorage (id) {
      this.shelfSelect = []
      if (id) {
        queryBySbIdSsId(id).then(res => {
          if (res.data.code === 200) {
            this.shelfSelect = res.data.obj
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    handleClick (tab) {
      this.activeName = tab.name
      this.onReset()
    },
    // 获取列表数据
    getList () {
      this.loadingTable = true
      if (this.activeName === 'pending') {
        this.auditState = 1
      } else if (this.activeName === 'myPending') {
        this.auditState = 2
      } else if (this.activeName === 'myAudited') {
        this.auditState = 3
      }
      const params = {
        criteriaVoList: [...this.tempList],
        queryPageName: ''
      }
      queryPageAllInventory(this.auditState, this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 搜索
    onSearch () {
      if (this.queryParams.storageName === undefined || this.queryParams.shelvesName === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.tempList = this.$queryParams(this.queryParams, 'noExpression')
        this.pageSize = 30
        this.currentPage = 1
        this.getList()
      }
    },
    // 重置
    onReset () {
      this.tempList = []
      this.pageSize = 30
      this.currentPage = 1
      this.queryParams = {
        shelfSelect: '',
        stockSelector: ''
      }
      this.getList()
    },
    selectableFun(row) {
      if (row.auditUser === null) {
        return true
      }
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    onBatch() {
      if (this.checkList.length < 1) {
        this.$message.error('请选择一条或者多条')
      } else {
        this.$refs.openOrCloseRefs.onInitial()
      }
    },
    onUpdataState() {
      const arr = []
      this.checkList.forEach(ele => {
        arr.push(ele.sisId)
      })
      updateAuditState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 1-认领，2-处理，3-提取
    claimantDetail (row) {
      const arr = []
      const arr1 = [row]
      arr1.forEach(ele => {
        arr.push(ele.sisId)
      })
      updateAuditState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 提取
    handleDetail (row) {
      updateAuditStateExtract(row.sisId, 3).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg)
          this.getList() // 刷新数据列表
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 处理
    toDetail (row) {
      this.$router.push({ name: 'reviewInventoryDetail', query: { sisId: row.sisId, activeName: row.auditState } })
    },
    // 查看
    toCheck (sisId, activeName) {
      this.$router.push({ name: 'reviewInventoryDetail', query: { sisId: sisId, activeName: activeName } })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}

</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 122px;
}
.number-wait {
  left: 245px;
}
.number-yetCreate {
  left: 365px;
}
</style>
